import axios from 'axios';
import authHeader from "./auth-header";

class GameService {
    getGames () {
        return axios.get(window.api_url + "/api/games");
    }

    getLimitGames (limit) {
        return axios.get(window.api_url + "/api/games/translate/" + limit);
    }

    getGamesByGenre (offset) {
        return axios.post(window.api_url + "/api/genres/games", {"genreOffset": offset}, {headers: authHeader()});
    }

    getGameyByFriends () {
        return axios.post(window.api_url + "/api/auth/friends/games", [], {headers: authHeader()});
    }

    getGameBySlug (slug) {
        return axios.get(window.api_url + "/api/game/" + slug);
    }

    rate (game_id, stars, text = "") {
        let formData = new FormData();
        formData.append('game_id', game_id);
        formData.append('stars', stars);
        formData.append('text', text);

        return axios.post(window.api_url + "/api/auth/rate", formData, {headers: authHeader()});
    }

    addGame (name_de, name_en, genres, publishers, price, playerMin, playerMax, playTimeMin, playTimeMax, ageMin, ageMax, description_de, description_en, date, image) {
        let formData = new FormData();
        formData.append('name_de', name_de);
        formData.append('name_en', name_en);
        for (let i = 0; i < genres.length; i++) {
            formData.append('genres[' + i + ']', genres[i]);
        }
        for (let i = 0; i < publishers.length; i++) {
            formData.append('publishers[' + i + ']', publishers[i]);
        }
        formData.append('price', price);
        formData.append('playerMin', playerMin);
        formData.append('playerMax', playerMax);
        formData.append('playTimeMin', playTimeMin);
        formData.append('playTimeMax', playTimeMax);
        formData.append('ageMin', ageMin);
        formData.append('ageMax', ageMax);
        formData.append('description_de', description_de);
        formData.append('description_en', description_en);
        formData.append('date', date);
        formData.append('image', image);

        return axios.post(window.api_url + "/api/auth/game", formData, {headers: authHeader()});
    }

    editGame (id, name_de, name_en, genres, publishers, price, playerMin, playerMax, playTimeMin, playTimeMax, ageMin, ageMax, description_de, description_en, date, image) {
        let formData = new FormData();
        formData.append('name_de', name_de);
        formData.append('name_en', name_en);
        for (let i = 0; i < genres.length; i++) {
            formData.append('genres[' + i + ']', genres[i]);
        }
        for (let i = 0; i < publishers.length; i++) {
            formData.append('publishers[' + i + ']', publishers[i]);
        }
        if (price !== null) {
            formData.append('price', price);
        }
        formData.append('playerMin', playerMin);
        formData.append('playerMax', playerMax);
        formData.append('playTimeMin', playTimeMin);
        formData.append('playTimeMax', playTimeMax);
        formData.append('ageMin', ageMin);
        if (ageMax !== null) {
            formData.append('ageMax', ageMax);
        }
        formData.append('description_de', description_de);
        formData.append('description_en', description_en);
        formData.append('date', date);
        formData.append('image', image);

        return axios.post(window.api_url + "/api/auth/game/" + id, formData, {headers: authHeader()});
    }

    updateGames (games) {
        let formData = new FormData();
        console.log(games);
        formData.append('games', JSON.stringify(games));

        return axios.post(window.api_url + "/api/auth/games/", formData, {headers: authHeader()});
    }

    filter (url, genres, publisher, playerCount, playTime, age, rating) {

        let formData = new FormData();
        for (let i = 0; i < genres.length; i++) {
            formData.append('genres[' + i + ']', genres[i]);
        }
        if (publisher !== null && typeof publisher !== "undefined") {
            formData.append('publisher', publisher);
        }
        if (playerCount !== null && typeof playerCount !== "undefined") {
            formData.append('playerMin', playerCount[0]);
            formData.append('playerMax', playerCount[1]);
        }
        if (playTime !== null && typeof playTime !== "undefined") {
            formData.append('playTimeMin', playTime[0]);
            formData.append('playTimeMax', playTime[1]);
        }
        if (age !== null && typeof age !== "undefined") {
            formData.append('ageMin', age[0]);
            formData.append('ageMax', age[1]);
        }
        if (rating !== null && typeof rating !== "undefined") {
            formData.append('rating', rating);
        }
        return axios.post(url, formData, {headers: authHeader()});
    }

    deleteGame (id) {
        return axios.delete(window.api_url + "/api/auth/game/" + id, {headers: authHeader()});
    }

}

export default new GameService();
